import { IRestaurant } from '@rbi-ctg/store';
import { DeliveryStatus, DeliveryStoreStatus } from 'generated/graphql-gateway';

import { GroqArgs, groqQuery } from './groq';

const projection = `
  _id,
  accessInstructions,
  isNonTraditional,
  chaseMerchantId,
  deliveryHours,
  diningRoomHours,
  drinkStationType,
  driveThruHours,
  driveThruLaneType,
  email,
  fastestServiceMode,
  franchiseGroupId,
  franchiseGroupName,
  frontCounterClosed,
  hasBreakfast,
  hasBurgersForBreakfast,
  hasDineIn,
  hasDelivery,
  hasDriveThru,
  hasMobileOrderDriveThru,
  hasMobileOrdering,
  hasParking,
  hasPlayground,
  hasTakeOut,
  hasWifi,
  hasLoyalty,
  isDarkKitchen,
  isHalal,
  isOrderEtaEnabled,
  latitude,
  longitude,
  mobileOrderingStatus,
  mobileOrderDriveThruHours,
  name,
  number,
  orderEtaValue,
  parkingType,
  phoneNumber,
  physicalAddress,
  playgroundType,
  pos,
  posRestaurantId,
  status,
  restaurantImage{..., asset->},
  vatNumber
`;

const storesByNumberQuery = `
  *[ _type == 'restaurant' && number == $storeNumber ] {
    ${projection}
  }
`;

export enum StoreStatus {
  OPEN = 'deliveryStoreOpen',
  CLOSED = 'deliveryStoresClosed',
  NO_DELIVERY = 'noDeliveryStores',
}

export declare interface IGetClosestAvailableDeliveryRestaurantResult {
  deliveryQuote: DeliveryStatus | null;
  storeStatus: StoreStatus;
  store: IRestaurant | null;
  nextEarliestOpen?: Date;
}

export const DeliveryStoreStatusToStoreStatusMap: Record<DeliveryStoreStatus, StoreStatus> = {
  [DeliveryStoreStatus.CLOSED]: StoreStatus.CLOSED,
  [DeliveryStoreStatus.NO_DELIVERY]: StoreStatus.NO_DELIVERY,
  [DeliveryStoreStatus.OPEN]: StoreStatus.OPEN,
};

type GetRestaurantsByStoreNumberArgs = GroqArgs<{ storeNumber: string }>;

export const getRestaurantsByStoreNumber = (
  endpoint: string,
  { storeNumber }: GetRestaurantsByStoreNumberArgs
) =>
  groqQuery<IRestaurant[], GetRestaurantsByStoreNumberArgs>(endpoint, storesByNumberQuery, {
    storeNumber,
  });
